import React, { FunctionComponent } from 'react';
import { toast } from 'react-toastify';
import { ToastOptions } from 'react-toastify/dist/types';
import {
  MessageType,
  PageMessageProps,
} from '@upstart/harmony/lib/legos/websiteTypes';
import './PageMessage.scss';

const PageMessage: FunctionComponent<PageMessageProps & {
  overrideToastOptions?: Partial<ToastOptions>;
}> = ({ headline, message, type, overrideToastOptions }) => {
  const defaultOptions: ToastOptions = {
    position: 'top-center',
    autoClose: 3000,
    closeButton: false,
    className: 'global-message',
    hideProgressBar: true,
    draggable: false,
    closeOnClick: true,
    draggablePercent: 30,
  };
  const getOpts = (messageType: MessageType) => {
    const opts = { ...defaultOptions };
    switch (messageType) {
      case MessageType.ERROR:
        opts.className = 'global-message global-message-error';
        opts.autoClose = false;
        opts.closeButton = true;
        opts.closeOnClick = false;
        break;
      case MessageType.SUCCESS:
        opts.className = 'global-message global-message-success';
        opts.draggable = true;
        break;
      case MessageType.INFO:
        opts.className = 'global-message global-message-info';
        opts.closeButton = true;
        opts.closeOnClick = false;
        break;
      default:
      // NOOP
    }
    return opts;
  };
  const getLabel = (messageType: MessageType) => {
    // TODO: TRANSLATE THESE STRINGS
    switch (messageType) {
      case MessageType.ERROR:
        return 'ERROR';
      case MessageType.SUCCESS:
        return 'SUCCESS';
      case MessageType.INFO:
        return 'INFO';
      default:
        return 'INFO';
    }
  };

  const label = headline || getLabel(type);
  const toastMessage = (
    <>
      <span className="global-message-label">{label}</span>
      {message}
    </>
  );

  const options: ToastOptions = overrideToastOptions
    ? { ...getOpts(type), ...overrideToastOptions }
    : getOpts(type);
  return <>{toast(toastMessage, options)}</>;
};

export default PageMessage;
